import React, { Component } from "react";
import { Link } from "react-router-dom";
import Price from "../../../Parts/Price";

export default class ProductDetails extends Component {
    render() {
        var price = 0;
        var salePrice = null;
        var onSale = false;
		var discountPercent = null;

        if (this.props.variations[0]) {
            price = this.props.variations[0].regularPrice;

            // If product is on sale
            if (this.props.variations[0].onSale === true) {
                onSale = true;
                salePrice = <Price className="price sale-price">{this.props.variations[0].price}</Price>;
				discountPercent = <span className="discount-percent">{(100 - Math.round((parseInt(this.props.variations[0].price) / parseInt(price)) * 100))}%</span>;
            }
        }

        var categoryBreadcrumbs = null;

        if (this.props.categories.length > 0) {
            var category = this.props.categories[0];
            categoryBreadcrumbs = <span className="product-breadcrumbs">
                <Link className="main" to={"/shop"}>Home</Link>
                <span className="separator">/</span>
                <Link className="second" to={category.uri}>{category.name}</Link>
            </span>;
        }

        return <div className="details-wrap">
            <div className="title-wrap">
                {categoryBreadcrumbs}
                <h1 className="product-title">{this.props.title}</h1>
            </div>

            <div className="price-wrap">
                <Price className={"price" + (onSale ? " regular-price-on-sale" : "")}>{price}</Price>
				{discountPercent}
                {salePrice}
            </div>
        </div>
    }
}